import { enumButtonLabelPosition } from "../constants";
import { QBasicButton } from "../CoreApp/QBasicButton";

export function AddViewerTextButton(parent, label, cmdCode, x, y, hoverCode, autoSize, fs) {
  var button = new QBasicButton();
  if (fs) {
    button.fFontString = fs;
  }
  button.InitBasicButton(parent, label, cmdCode, x, y);
  button.fLabelPosition = enumButtonLabelPosition.center;
  if (hoverCode && hoverCode !== "") button.SetHoverCode(hoverCode);

  return button;
}
